module.exports = __webpack_public_path__ + "img/handraw_date de livraison.2db491ac.svg";